<template>
  <HelloWorld></HelloWorld>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/Quiz.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}
</script>
